var map = {
	"./WIS_deliverables.png": 7818,
	"./WIS_dev-process.png": 7512,
	"./WIS_early-designs.png": 5332,
	"./WIS_feedback.png": 3710,
	"./assets.png": 9474,
	"./design-system_07-21-2023.png": 2217,
	"./icons/arrow-left.svg": 1833,
	"./icons/arrow-right.svg": 153,
	"./icons/close.svg": 420,
	"./icons/ham.svg": 6347,
	"./icons/play.svg": 5590,
	"./jerusalem.jpg": 5875,
	"./jones_davy_writtenInStone.png": 2340,
	"./logo.png": 6949,
	"./me-jordan.png": 3615,
	"./mount-temptation.jpg": 3856,
	"./people.png": 9833,
	"./process_initial.png": 7470,
	"./wis-brand.png": 6070,
	"./wis-laptop-mockup.png": 5597,
	"./wis-mac-mockup.png": 2674,
	"./wis_logo.svg": 400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;